import { render } from "./Index.vue?vue&type=template&id=419ccf61&scoped=true"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=419ccf61&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419ccf61"],['__file',"resources/js/modules/labelinsight-products/components/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "419ccf61"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('419ccf61', __exports__)) {
    api.reload('419ccf61', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=419ccf61&scoped=true", () => {
    api.rerender('419ccf61', render)
  })

}


export default __exports__